// extracted by extract-css-chunks-webpack-plugin
module.exports = {"bigbutton":"BigButtonDisabled__bigbutton--3QN0j"};